<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // RFID电子标签序列号
            label: 'RFID电子标签',
            value: 'labelCode',
            type: 'input',
            placeholder: '请输入RFID电子标签序列号',
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_SERVICE_BUSI_TYPE',
    });
    this.searchBoxData.serviceTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
